import jqueryScript from "./assets/plugins/js/jquery-3.7.1.min.js?url";
import fancyboxScript from "./assets/plugins/js/fancybox.min.js?url";
import slickScript from "./assets/plugins/js/slick.min.js?url";

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
            if (
                existingScript.readyState === "complete" ||
                existingScript.readyState === "loaded"
            ) {
                resolve();
                return;
            }
        }

        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        document.head.appendChild(script);
    });
}

Promise.resolve()
    .then(() => loadScript(jqueryScript))
    .then(() => {
        return new Promise((resolve) => {
            const checkJQuery = () => {
                if (window.$ && window.jQuery) {
                    resolve();
                } else {
                    setTimeout(checkJQuery, 10);
                }
            };
            checkJQuery();
        });
    })
    .then(() => {
        return Promise.all([
            loadScript(fancyboxScript),
            loadScript(slickScript),
        ]);
    })
    .then(() => {
        initializeApp();
    });

function initForms() {
    $("#respostaContato").on("input", function () {
        this.setCustomValidity("");
    });

    $('form[name="formContato"]').on("submit", function (event) {
        event.preventDefault();

        const campoResposta = document.getElementById("respostaContato");
        const resposta = campoResposta.value.trim();

        if (resposta !== "16") {
            campoResposta.setCustomValidity(
                "Por favor, responda corretamente a operação matemática: 9 + 7 = ?",
            );
            campoResposta.reportValidity();
            return false;
        }

        campoResposta.setCustomValidity("");

        $.ajax({
            url: $(this).attr("action"),
            type: "POST",
            data: $(this).serialize(),
            success: function (response) {
                $("#modalSucesso").fadeIn();
            },
            error: function (xhr, status, error) {
                $("#modalErro").fadeIn();
            },
        });
    });

    $('form[name="formModal"]').on("submit", function (event) {
        event.preventDefault();

        const campoResposta = document.getElementById("respostaModal");
        const resposta = campoResposta.value.trim();

        if (resposta !== "16") {
            campoResposta.setCustomValidity(
                "Por favor, responda corretamente a operação matemática: 9 + 7 = ?",
            );
            campoResposta.reportValidity();
            return false;
        }

        campoResposta.setCustomValidity("");

        $.ajax({
            url: $(this).attr("action"),
            type: "POST",
            data: $(this).serialize(),
            success: function (response) {
                $("#modalSucesso").fadeIn();
            },
            error: function (xhr, status, error) {
                $("#modalErro").fadeIn();
            },
        });
    });
}

function initModals() {
    $(".abre-modal").on("click", function () {
        var modal = $(this).data("modal");
        $("#" + modal).fadeIn();
    });

    $(".modal-content .close, .modal .close").on("click", function () {
        $(this).closest(".modal").fadeOut();
    });

    $(".modal").on("click", function (e) {
        if (e.target === this) {
            $(this).fadeOut();
        }
    });

    $(".modal-content").on("click", function (event) {
        event.stopPropagation();
    });

    $(".menu-link.email").on("click", function () {
        $("#modalFormulario").fadeIn();
    });

    $(".menu-link.phone").on("click", function () {
        $("#modalTelefone").fadeIn();
    });

    $(".link-politica-de-privacidade").on("click", function () {
        $("#modalPoliticaDePrivacidade").fadeIn();
    });

    $(".link-ficha-tecnica").on("click", function () {
        $("#modalFichaTecnica").fadeIn();
    });

    $(".btn-localizacao").on("click", function () {
        $("#modalLocalizacao").fadeIn();
    });

    $("#assistir-video").on("click", function () {
        $("#modalVideo").fadeIn();
    });

    const modalVideo = document.getElementById("modalVideoPlayer");
    const videoPlayBtn = document.getElementById("videoPlayBtn");

    if (modalVideo && videoPlayBtn) {
        modalVideo.addEventListener("click", function () {
            modalVideo.play();
        });

        videoPlayBtn.addEventListener("click", function () {
            modalVideo.play();
        });

        modalVideo.addEventListener("play", function () {
            videoPlayBtn.style.display = "none";
            modalVideo.setAttribute("controls", "controls");
        });

        modalVideo.addEventListener("pause", function () {
            videoPlayBtn.style.display = "flex";
            modalVideo.removeAttribute("controls");
        });

        modalVideo.addEventListener("ended", function () {
            videoPlayBtn.style.display = "flex";
            modalVideo.removeAttribute("controls");
        });

        $(".modal-content .close, .modal .close").on("click", function () {
            if (modalVideo) {
                modalVideo.pause();
                modalVideo.currentTime = 0;
                videoPlayBtn.style.display = "flex";
                modalVideo.removeAttribute("controls");
            }
        });
    }
}

function initMenu() {
    $(".abre-menu").on("click", function () {
        $("#menu").addClass("show");
    });

    $(".close-menu").on("click", function () {
        $("#menu").removeClass("show");
    });

    $(".nav-sections").on("click", function () {
        var section = $(this).attr("href");
        $(".close-menu").click();

        if (section && $(section).length > 0) {
            $("html, body").animate(
                { scrollTop: $(section).offset().top },
                500,
            );
        }
    });

    $(".animated-menu.mobile .menu-list .menu-item").on("click", function (e) {
        e.stopPropagation();
        $(".animated-menu.mobile .menu-list").toggleClass("open");
    });

    $(document).on("click", function (e) {
        const $menu = $(".animated-menu.mobile .menu-list");

        if (
            !$(e.target).closest(".animated-menu.mobile").length &&
            $menu.hasClass("open")
        ) {
            $menu.removeClass("open");
        }
    });
}

function initSlick() {
    const prevArrow = (className) =>
        '<button type="button" class="slick-prev ' +
        className +
        '" aria-label="Anterior">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">' +
        '<path d="M55.8335 35.1079L15.0002 35.1079" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M35 55.5247L14.5833 35.108L35 14.6913" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>";

    const nextArrow = (className) =>
        '<button type="button" class="slick-next ' +
        className +
        '" aria-label="Próximo">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">' +
        '<path d="M14.5835 35.1079H55.4168" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M35 14.6912L55.4167 35.1078L35 55.5245" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>";

    $(".slider-galeria-lazer-areas-comuns").slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(".slider-galeria-lazer-apartamentos").slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(".slider-tab-plantas").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        focusOnSelect: true,
        asNavFor: ".slider-plantas",
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".slider-plantas").slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        asNavFor: ".slider-tab-plantas",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                },
            },
        ],
    });

    $(".slider-tab-implantacao").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        focusOnSelect: true,
        asNavFor: ".slider-implantacao",
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".slider-implantacao").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        asNavFor: ".slider-tab-implantacao",
    });

    $(".slider-arquitetura").slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 300,
        centerMode: true,
        centerPadding: "0",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    variableWidth: false,
                    fade: true,
                    cssEase: "linear",
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: prevArrow(),
                    nextArrow: nextArrow(),
                },
            },
        ],
    });

    $(".slider-galeria-mosaico").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(".slider-galeria-mosaico-localizacao").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(window).on("resize", function () {
        $(".slider-arquitetura").slick("refresh");
    });
}

function initFancybox() {
    Fancybox.bind("[data-fancybox]", {});
}

function initInfraestrutura() {
    const toggleBtn = document.getElementById("infraestrutura-toggle-btn");
    const extraContent = document.querySelector(
        ".infraestrutura-extra-content",
    );
    const section = document.getElementById("infraestrutura");

    if (toggleBtn && extraContent) {
        toggleBtn.addEventListener("click", function () {
            const isHidden =
                extraContent.style.display === "none" ||
                !extraContent.style.display;

            if (isHidden) {
                extraContent.style.display = "block";

                extraContent.offsetHeight;

                setTimeout(() => {
                    extraContent.classList.add("visible");
                }, 10);

                toggleBtn.classList.add("active");

                setTimeout(() => {
                    extraContent.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }, 300);
            } else {
                if (section) {
                    section.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }

                setTimeout(() => {
                    extraContent.classList.remove("visible");
                }, 300);

                toggleBtn.classList.remove("active");

                setTimeout(() => {
                    extraContent.style.display = "none";
                }, 800);
            }
        });
    }
}

function mascaraTelefone(event) {
    let tecla = event.key;
    let telefone = event.target.value.replace(/\D+/g, "");

    if (/^[0-9]$/i.test(tecla)) {
        telefone = telefone + tecla;
        let tamanho = telefone.length;

        if (tamanho >= 12) {
            return false;
        }

        if (tamanho > 10) {
            telefone = telefone.replace(
                /^(\d\d)(\d{5})(\d{4}).*/,
                "($1) $2-$3",
            );
        } else if (tamanho > 5) {
            telefone = telefone.replace(
                /^(\d\d)(\d{4})(\d{0,4}).*/,
                "($1) $2-$3",
            );
        } else if (tamanho > 2) {
            telefone = telefone.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
            telefone = telefone.replace(/^(\d*)/, "($1");
        }

        event.target.value = telefone;
    }

    if (!["Backspace", "Delete"].includes(tecla)) {
        return false;
    }
}

window.mascaraTelefone = mascaraTelefone;

function initializeApp() {
    $(document).ready(function () {
        setTimeout(() => {
            document.body.classList.remove("preload");
        }, 100);

        $(".tab-links a").on("click", function (e) {
            e.preventDefault();
            var currentAttrValue = $(this).attr("href");

            $(this)
                .parent("li")
                .addClass("active")
                .siblings()
                .removeClass("active");
            $(".tab" + currentAttrValue)
                .addClass("active")
                .siblings()
                .removeClass("active");
        });

        $(".tab-galeria-lazer .tab-links li a").on("click", function (e) {
            e.preventDefault();

            const currentAttrValue = $(this).attr("href");

            if (currentAttrValue === "#areas-comuns") {
                $(".slider-galeria-lazer-areas-comuns").slick("refresh");
                $(".slider-galeria-lazer-apartamentos").slick("slickGoTo", 0);
            } else if (currentAttrValue === "#apartamentos") {
                $(".slider-galeria-lazer-apartamentos").slick("refresh");
                $(".slider-galeria-lazer-areas-comuns").slick("slickGoTo", 0);
            }
        });

        initFancybox();

        initSlick();

        initForms();

        initModals();

        initMenu();

        initInfraestrutura();

        initStickyBoxSocial();

        initVideoControls();

        initVistaImageSwitcher();
    });
}

function initStickyBoxSocial() {
    const boxSocial = $(".box-social");
    const contatoSection = $("footer");

    if (boxSocial.length && contatoSection.length) {
        let ticking = false;
        let currentState = "visible";

        function updateBoxVisibility() {
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const contatoOffset = contatoSection.offset().top;

            const hidePoint = contatoOffset - windowHeight + 100;

            if (scrollTop >= hidePoint && currentState !== "hidden") {
                currentState = "hidden";
                boxSocial.css({
                    opacity: "0",
                    "pointer-events": "none",
                });
            } else if (scrollTop < hidePoint && currentState !== "visible") {
                currentState = "visible";
                boxSocial.css({
                    opacity: "1",
                    "pointer-events": "auto",
                });
            }

            ticking = false;
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateBoxVisibility);
                ticking = true;
            }
        }

        $(window).on("scroll", requestTick);
        $(window).on("resize", function () {
            currentState = "";
            requestTick();
        });
    }
}

function pauseAllVideos() {
    $(".video-container video").each(function () {
        this.pause();
        this.controls = false;
        $(this).closest(".video-container").removeClass("playing");
    });
}

function initVideoControls() {
    $(".video-container").on("click", function (e) {
        e.preventDefault();

        const activeTab = $(".tab-obras.active").attr("id").includes("videos");

        if (!activeTab) {
            return;
        }

        e.stopPropagation();

        const video = $(this).find("video")[0];
        const container = $(this);

        if (video) {
            if (video.paused) {
                pauseAllVideos();

                video.volume = 1.0;
                video.controls = true;

                video
                    .play()
                    .then(() => {
                        container.addClass("playing");
                    })
                    .catch((e) => {
                        console.log("Erro ao reproduzir vídeo:", e);
                    });
            } else {
                video.pause();
                video.controls = false;
                container.removeClass("playing");
            }
        }
    });

    $(".video-container video").on("play", function () {
        $(this).closest(".video-container").addClass("playing");
        this.controls = true;
    });

    $(".video-container video").on("pause", function () {
        $(this).closest(".video-container").removeClass("playing");
        this.controls = false;
    });

    $(".video-container video").on("ended", function () {
        $(this).closest(".video-container").removeClass("playing");
        this.controls = false;
    });

    $(".slider-obras").on("afterChange", function (event, slick, currentSlide) {
        pauseAllVideos();
    });
}

function initVistaImageSwitcher() {
    const vistaButtons = document.querySelectorAll(
        "#vistas button[data-vista], #vistas .btn-tab-mobile[data-vista]",
    );
    const vistaImages = document.querySelectorAll("#vistas .vista-img");

    vistaButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const vistaType = this.getAttribute("data-vista");

            vistaButtons.forEach((btn) => {
                btn.classList.remove("active");
            });

            vistaImages.forEach((img) => {
                img.classList.remove("active");
            });

            this.classList.add("active");

            const targetImage = document.querySelector(
                `#vistas .vista-img[data-vista="${vistaType}"]`,
            );

            if (targetImage) {
                targetImage.classList.add("active");

                const allTexts = document.querySelectorAll(
                    `#vistas .texto-mobile`,
                );

                if (allTexts.length > 0) {
                    allTexts.forEach((text) => {
                        text.classList.remove("active");
                    });

                    const targetText = document.querySelector(
                        `#vistas .texto-mobile[data-vista="${vistaType}"]`,
                    );

                    if (targetText) {
                        targetText.classList.add("active");
                    }
                }
            }
        });
    });
}
